import {
  ASSIGN_COURIER,
  ASSIGN_ITEMS_TO_BOX,
  DECLINE_REQUEST,
  GET_REQUESTED_ITEM_DETAILS,
  GET_REQUESTS,
  GET_REQUEST_DETAILS,
  GET_REQUEST_HISTORY,
  REQUEST_IN,
  REQUEST_ITEM,
  REQUEST_OUT,
  UPDATE_REQUEST,
  UPDATE_REQUEST_IN,
  VALIDATE_ITEMS,
} from '../actionTypes';

const initialState = {
  requests: [],
  ongoing: [],
  done: [],
  data: [],
  histories: [],
  isLoading: false,
  error: false,
  message: '',
  newRequestData: {},
  newRequest: false,
  selectedRequest: {},
  selectedRequestedItem: {},
  courierSelected: false,
  itemsValidated: false,
  newRequestItem: false,
  requestOutSuccess: false,
  currentPage: 1,
  totalPage: 1,
  totalData: 0,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case `${GET_REQUEST_HISTORY}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        currentPage: 0,
      };
    case `${GET_REQUEST_HISTORY}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQUEST_HISTORY}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        histories: payload.data.data?.data,
        currentPage: payload.data.data?.current_page,
        totalPage: payload.data.data?.total_page,
        isLoading: false,
      };
    case `${REQUEST_IN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newRequest: false,
      };
    case `${REQUEST_IN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${REQUEST_IN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newRequest: true,
        newRequestData: payload?.data?.data,
      };
    case `${UPDATE_REQUEST_IN}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newRequest: false,
      };
    case `${UPDATE_REQUEST_IN}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${UPDATE_REQUEST_IN}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newRequest: true,
        newRequestData: payload?.data?.data,
      };
    case `${DECLINE_REQUEST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${DECLINE_REQUEST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${DECLINE_REQUEST}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedRequest: {
          ...state.selectedRequest,
          status: 'Admin Canceled',
        },
      };
    case `${REQUEST_ITEM}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        newRequestItem: false,
      };
    case `${REQUEST_ITEM}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${REQUEST_ITEM}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        newRequestItem: true,
      };

    case `${GET_REQUESTS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        itemsValidated: false,
        selectedRequest: {},
      };
    case `${GET_REQUESTS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQUESTS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        requests: payload.data.requests || [],
        ongoing: payload.data.on_going || [],
        done: payload.data.finish || [],
        data: payload.data.data || [],
        currentPage: payload.data?.current_page,
        totalPage: payload.data?.total_page,
        totalData: payload.data?.total_data,
      };

    case `${GET_REQUEST_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        courierSelected: false,
        selectedRequest: {},
        newRequest: false,
        newRequestData: {},
      };
    case `${GET_REQUEST_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQUEST_DETAILS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedRequest: payload.data.data,
      };

    case `${GET_REQUESTED_ITEM_DETAILS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case `${GET_REQUESTED_ITEM_DETAILS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${GET_REQUESTED_ITEM_DETAILS}_FULFILLED`:
      return {
        ...state,
        error: false,
        message: '',
        selectedRequestedItem: payload.data.data,
        isLoading: false,
      };

    case `${UPDATE_REQUEST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        courierSelected: false,
      };
    case `${UPDATE_REQUEST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${UPDATE_REQUEST}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedRequest: payload.data.data,
      };

    case `${ASSIGN_COURIER}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        courierSelected: false,
      };
    case `${ASSIGN_COURIER}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data || payload?.response?.message,
        error: true,
      };
    case `${ASSIGN_COURIER}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedRequest: payload.data.data,
        courierSelected: true,
      };

    case `${VALIDATE_ITEMS}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        itemsValidated: false,
      };
    case `${VALIDATE_ITEMS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data || payload?.response?.message,
        error: true,
      };
    case `${VALIDATE_ITEMS}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        selectedRequest: payload.data.data,
        itemsValidated: true,
      };

    case `${ASSIGN_ITEMS_TO_BOX}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        validatedRequest: '',
      };
    case `${ASSIGN_ITEMS_TO_BOX}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${ASSIGN_ITEMS_TO_BOX}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        validatedRequest: payload.requestId,
        selectedRequest: payload.data.data,
      };
    case `${REQUEST_OUT}_PENDING`:
      return {
        ...state,
        isLoading: true,
        error: false,
        requestOutSuccess: false,
      };
    case `${REQUEST_OUT}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.data || payload?.response?.data?.message,
        error: true,
      };
    case `${REQUEST_OUT}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        error: false,
        message: '',
        requestOutSuccess: true,
      };

    default:
      return state;
  }
}
